<script setup>
import Button from '@/common/Button.vue';

// No logic required for this trigger-only component
</script>

<template>
    <Button
        class="border"
        data-bs-toggle="offcanvas"
        data-bs-target="#contentTypeFieldsetOffcanvas"
        aria-controls="contentTypeFieldsetOffcanvas"
    >
        <i class="bi bi-plus-lg"/>
        Fieldset
    </Button>
</template>